import React, { Component } from 'react';
import PropTypes from 'prop-types';
import EditDevice from '../Content/EditDevice';
import InputOutputDevice from '../Content/InputOutputDevice';
import PetroleumSetting from '../Content/PetroleumSetting';
import AD from '../Content/AD';
import SpecialConfig from '../Content/SpecialConfig';
import UserDevice from '../Content/UserDevice';
import DeviceAlert from '../Content/DeviceAlert';
import moment from 'moment';
import { checkStatus, setLoader } from '../../../../util/util';
import {AlertConfirm, AlertCommit} from '../../../Modals/AlertBar';

class DeviceManangment extends Component {

    constructor(props) {
        super(props);
        this.state  = {
            deviceList:[],
            notification:false,
            manageDevice: {},
            showModalConfirmManageDevice: false,
            showModalCancelManageDevice: false,
            petroleum_from_date:moment(),
            petroleum_to_date:moment(),
            statusAlert:true,
            deviceInfo:{},
            inputOutputs:[],
            ad:[],
            specialSetting:{},
            alert:[],
            unit_id:'',

        };
    }

    componentWillMount(){
        const { deviceSelected } = this.props;
        this.setState({
            petroleum_from_date : deviceSelected.install_date==null?null: this.dateWrapper(moment(deviceSelected.petroleum_from_date)),
            petroleum_to_date: deviceSelected.expire_date==null?null: this.dateWrapper(moment(deviceSelected.petroleum_to_date)),
        });
    }

    dateWrapper(rDate){
        let rDateWrapper=rDate;
        if(rDate!=null && rDate.toObject().years>2500){
          rDateWrapper=moment((rDate.toObject().years-543)+'-'+rDate.toObject().months+'-'+rDate.toObject().date);
        }
        return rDateWrapper;
      }

    componentDidMount(){
        this.getDeviceInfo();

    }
    componentWillUnmount(){
        this.setState({
            deviceList: []
        })

    }

    getDeviceInfo = () =>{
        const {
            token,
            deviceSelected,
            history
        } = this.props;
        let user_ids = typeof deviceSelected.device_id !== 'undefined' ? deviceSelected.device_id : history.location.state.deviceId;
        setLoader(true)
        fetch(`http://203.150.199.244/api/admin/getDeviceInfo/${user_ids}`, {
        // fetch(`http://203.150.199.244/api/admin/getDeviceInfo/18647`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                // "user_id": user_id,
                // "user_name": user_name,
                "token": token
            },
            body: JSON.stringify({
                // "filter":deviceSearch
            })
            })
            .then(response => { return checkStatus(response)})
            .then(data => {

                // let deviceInfo = {};
                // let specialSetting = [];
                // let inputOutputs = [];
                // let ad =[];
                // let alert = [];

                data.RESULT_DATA.map((device,key) => {
                    this.setState({

                        deviceInfo:{
                            install_with_rfid:device.install_with_rfid,
                            network_operator:device.network_operator,
                            serial: device.serial,
                            imei: device.imei,
                            sim_no: device.sim_no,
                            model: device.model,
                            vendor: device.vendor,
                            device_id: device.device_id,
                            user_id: device.user_id,
                            dealer_id: device.dealer_id,
                            customer_id: device.customer_id,
                            create_user: device.create_user,
                            last_upd_user: device.last_upd_user,
                            create_dtm: device.create_dtm,
                            last_upd_dtm: device.last_upd_dtm,
                            device_driver: device.device_driver,
                            device_group: device.device_group,
                            device_model: device.device_model,
                            device_no: device.device_no,
                            expire_date: device.expire_date,
                            install_date: device.install_date,
                            is_dlt_alert: device.is_dlt_alert,
                            petroleum_from_date: device.petroleum_from_date,
                            petroleum_km_rate: device.petroleum_km_rate,
                            petroleum_liter_rate: device.petroleum_liter_rate,
                            petroleum_to_date: device.petroleum_to_date,
                            remarks: device.remarks,
                            reseller_note: device.reseller_note,
                            speed_limit: device.speed_limit,
                            symbol_color: device.symbol_color,
                            symbol_id: device.symbol_id,
                            last_paid_sim_no: device.last_paid_sim_no,
                            visible: device.visible,
                            type: device.type,
                            icon_label: device.icon_label
                        },
                        specialSetting:device.special_setting,
                        inputOutputs:device.input_outputs,
                        ad:device.ad,
                        alert:device.alert,
                        unit_id:device.unit_id,
                    });
                    setLoader(false)
                });

            })
            .catch(function (err) {
                console.log('err:', err);
                setLoader(false)
                // POST failed...
            });
    }

    onClose(){
        this.props.onClose();
    }

    onValidateComplete = (data) => {
        this.setState({manageDevice: data});

        AlertConfirm("แก้ไขข้อมูลอุปกรณ์"," ").then(isOk=>{
            if(isOk){
                
                const {
                    user_name,
                    user_id,
                    sideBarName,
                    deviceSelected,
                    token
                } = this.props;
                const { dataCreateNewUser, deviceSelect ,manageDevice,petroleum_from_date,petroleum_to_date} = this.state;
        
                // if (sideBarName === 'deviceInformation') {
                    fetch(`http://203.150.199.244/api/admin/updateDevice/${deviceSelected.device_id}`, {
                        method: 'post',
                        headers: {
                            "Content-Type": "application/json; charset=utf-8",
                            // "user_id": user_id,
                            // "user_name": user_name,
                            "token": token,
                        },
                        body: JSON.stringify({
                            "device_id":manageDevice.device_id,
                            "device_group": manageDevice.device_group, // "จัดกลุ่ม"
                            "device_no": manageDevice.device_no, // "ทะเบียนรถ"
                            "device_model": manageDevice.device_model, // "รุ่นรถ"
                            "device_driver": manageDevice.device_driver, // "คนขับรถ"
                            "speed_limit": manageDevice.speed_limit, // "จำกัดความเร็ว กม./ชม."
                            "petroleum_km_rate": manageDevice.petroleum_km_rate, // "อัตราการใช้น้ำมัน กม./ลิตร"
                            "petroleum_liter_rate": manageDevice.petroleum_liter_rate, // "อัตราการใช้น้ำมัน ลิตร/ชม."
                            "remarks": manageDevice.remarks, // "หมายเหตุ"
                            "is_dlt_alert": manageDevice.is_dlt_alert, // "แจ้งเตือนกรมขนส่ง"
                            "install_date": manageDevice.install_date, // "วันที่ติดตั้ง"
                            "expire_date": manageDevice.expire_date, // "วันครบกำหนด"
                            "reseller_note": manageDevice.reseller_note, // "Reseller Note"
                            "symbol_id": manageDevice.symbol_id, // "ตั้งค่า Marker สัญลักษณ์"
                            "symbol_color": manageDevice.symbol_color, // "ตั้งค่า Marker สี"
                            // "petroleum_from_date": petroleum_from_date, // "ตั้งค่าน้ำมัน เริ่มจากวันที่"
                            // "petroleum_to_date": petroleum_to_date // "ตั้งค่าน้ำมัน ถึงวันที่"
                            "valiable" : manageDevice.valiable,
                            "type": manageDevice.type,
                            "icon_label": manageDevice.icon_label
                        })
                    })
                        .then(response => { return checkStatus(response)})
                        .then((data) => {

                            if(data.RESULT_STATUS == "000") {
                                this.setState({showModalConfirmManageDevice: true});
                                AlertCommit(true, "บันทึกข้อมูลเรียบร้อยแล้ว");
                            }
                        else{
                            AlertCommit(false,data.RESULT_STATUS + ": "+data.RESULT_MESSAGE);
                        }

                            // this.setState({
                            //     showModalConfirmManageDevice: false,
                            //     // isShowCreateNewDealer: false,
                            //     // notification: true,
                            //
                            // })
                        })
                        .catch(function (err) {
                            console.log('err:', err);
                            // POST failed...
                        });
                      

            }
            
        });
    }

    onClickCancelManageDevice = (status) => {
        this.setState({showModalConfirmManageDevice: status});
    }

    onEditDeviceClose(){
        this.btnEditClose.click();
        this.setState({
            isShowEdit:false
        })
    }

    onClickBack = () => {
        const {onBack} = this.props;
        onBack();
    }

    handleEditDevice = () => {
        
        AlertConfirm("แก้ไขข้อมูลอุปกรณ์"," ").then(isOk=>{
            if(isOk){
                
                const {
                    user_name,
                    user_id,
                    sideBarName,
                    deviceSelected,
                    token
                } = this.props;
                const { dataCreateNewUser, deviceSelect ,manageDevice,petroleum_from_date,petroleum_to_date} = this.state;
        
                // if (sideBarName === 'deviceInformation') {
                    fetch(`http://203.150.199.244/api/admin/updateDevice/${deviceSelected.device_id}`, {
                        method: 'post',
                        headers: {
                            "Content-Type": "application/json; charset=utf-8",
                            // "user_id": user_id,
                            // "user_name": user_name,
                            "token": token,
                        },
                        body: JSON.stringify({
                            "device_group": manageDevice.device_group, // "จัดกลุ่ม"
                            "device_no": manageDevice.device_no, // "ทะเบียนรถ"
                            "device_model": manageDevice.device_model, // "รุ่นรถ"
                            "device_driver": manageDevice.device_driver, // "คนขับรถ"
                            "speed_limit": manageDevice.speed_limit, // "จำกัดความเร็ว กม./ชม."
                            "petroleum_km_rate": manageDevice.petroleum_km_rate, // "อัตราการใช้น้ำมัน กม./ลิตร"
                            "petroleum_liter_rate": manageDevice.petroleum_liter_rate, // "อัตราการใช้น้ำมัน ลิตร/ชม."
                            "remarks": manageDevice.remarks, // "หมายเหตุ"
                            "is_dlt_alert": manageDevice.is_dlt_alert, // "แจ้งเตือนกรมขนส่ง"
                            "install_date": manageDevice.install_date, // "วันที่ติดตั้ง"
                            "expire_date": manageDevice.expire_date, // "วันครบกำหนด"
                            "reseller_note": manageDevice.reseller_note, // "Reseller Note"
                            "symbol_id": manageDevice.symbol_id, // "ตั้งค่า Marker สัญลักษณ์"
                            "symbol_color": manageDevice.symbol_color, // "ตั้งค่า Marker สี"
                            // "petroleum_from_date": petroleum_from_date, // "ตั้งค่าน้ำมัน เริ่มจากวันที่"
                            // "petroleum_to_date": petroleum_to_date // "ตั้งค่าน้ำมัน ถึงวันที่"
                            "valiable": manageDevice.valiable,
                            "type": manageDevice.type,
                            "icon_label": manageDevice.icon_label
                        })
                    })
                        .then(response => { return checkStatus(response)})
                        .then((data) => {

                            if(data.RESULT_STATUS == "000") {
                                this.setState({showModalConfirmManageDevice: true});
                                AlertCommit(true, "บันทึกข้อมูลเรียบร้อยแล้ว");
                            }
                        else{
                            AlertCommit(false,data.RESULT_STATUS + ": "+data.RESULT_MESSAGE);
                        }

                            // this.setState({
                            //     showModalConfirmManageDevice: false,
                            //     // isShowCreateNewDealer: false,
                            //     // notification: true,
                            //
                            // })
                        })
                        .catch(function (err) {
                            console.log('err:', err);
                            // POST failed...
                        });
            }
            
        });
        
        // }
    }

    render(){

        const { deviceSelected,user_id,user_name,token,userLevel,history } = this.props;
        let user_ids = deviceSelected.device_id;
        const {
            notification,
            showModalConfirmManageDevice,
            deviceInfo,
            specialSetting,
            inputOutputs,
            ad,
            alert,
            unit_id
        } = this.state;
        return(

            <div className="container-fluid">
                <div className="card">
                    <div className="card-header">
                        <h5 className=""> <i class="fa fa-arrow-left" aria-hidden="true" style={{color: '#7386D5',cursor: 'pointer'}} onClick={this.onClickBack}></i> รายการตั้งค่าเครื่อง</h5>
                    </div>
                    <div className="card-body">
                        {/* <h5>บันทึกข้อมูลการตั้งค่าเครื่อง</h5>
                        <br /> */}
                        {showModalConfirmManageDevice &&
                            <h5>สำเร็จ</h5>
                        }
<div className="row" >
                {/* { notification &&
                    <AlertBar status={this.state.statusAlert}/>
                 } */}

                    <EditDevice
                        deviceInfo={deviceInfo}
                        onSubmit={this.onValidateComplete}
                        user_id={user_id}
                        user_name={user_name}
                        token={token}
                        userLevel={this.props.userLevel}
                        showModalConfirmManageDevice={showModalConfirmManageDevice}
                    />
                </div>
                { userLevel !== 3 && userLevel !== 4 && 
                    
                    <div className="row" style={{paddingTop:20}}>
                        <PetroleumSetting/>
                    </div>
                }
                
                { userLevel !== 3 && userLevel !== 4 &&
                    <div className="row" style={{paddingTop:20}}>
                        <InputOutputDevice
                            inputOutputs={inputOutputs}
                            user_id={user_id}
                            user_ids={user_ids}
                            user_name={user_name}
                            token={token}
                        />
                    </div>
                }

                { userLevel !== 3 && userLevel !== 4 &&
                    <div className="row" style={{paddingTop:20}}>
                        <AD
                            user_id={user_id}
                            user_name={user_name}
                            token={token}
                            ad={ad}
                            user_ids={user_ids}
                        />
                    </div>
                }

                { userLevel !== 3 && userLevel !== 4 &&
                    <div className="row" style={{paddingTop:20}}>
                        <SpecialConfig
                            specialSetting={specialSetting}
                            user_id={user_id}
                            user_name={user_name}
                            token={token}
                            deviceId={deviceSelected.device_id}
                            unit_id={unit_id}
                            userLevel={this.props.userLevel}
                        />
                    </div>
                }

                { userLevel !== 3 && userLevel !== 4 &&
                    <div className="row" style={{paddingTop:20}}>
                        <UserDevice
                            deviceSelected={deviceSelected}
                            deviceInfo={deviceInfo}
                            deviceId = {deviceSelected.device_id}
                            onSubmit={this.onValidateComplete}
                            user_id={user_id}
                            user_name={user_name}
                            token={token}
                            history={history}
                        />
                    </div>
                }
                
                <div className="row" style={{paddingTop:20}}>
                    <DeviceAlert
                        getDeviceInfo={this.getDeviceInfo}
                        deviceId={deviceSelected.device_id}
                        alert={alert}
                        user_id={user_id}
                        user_name={user_name}
                        token={token}
                    />
                </div>
                <br/>
                    </div>
                </div>
                

        </div>

        );
    }
}
DeviceManangment.defaultProps = {
    deviceSelected:{}
}

DeviceManangment.propTypes = {
    deviceSelected: PropTypes.object,
    // onSubmit: PropTypes.func.isRequired,
    user_name: PropTypes.string.isRequired,
    user_id: PropTypes.number.isRequired,
    token: PropTypes.string.isRequired,
    userLevel:PropTypes.number.isRequired,
    onBack:PropTypes.func,
    history: PropTypes.func.isRequired,
    
}


export default DeviceManangment;



// WEBPACK FOOTER //
// ./src/app/view/components/AdminConfig/Content/DeviceManangment.js